import useSalonController from "@jury/api/useSalonController"
import useActions from "./hooks/useActions"
import useApi from "./hooks/useApi"
import useAttributes from "./hooks/useAttributes"
import useHooks from "./hooks/useHooks"
import useMethods from "./hooks/useMethods"

export default function useSalon(id: string | number): Jury.Models.Salon {
    const controller = useSalonController()
    const response = controller.show(id).use(`jury:salon:${id}`)

    const attrs = useAttributes(response)
    const api = useApi(id, controller)
    const methods = useMethods(response)
    const actions = useActions(response, api, methods)
    const use = useHooks(response, api, methods, actions)

    return { 
        state: response.data, 
        setState: response.setData, 
        fresh: response.fresh,
        api,
        methods,
        actions,
        use,
        attrs
    }
}